import { decorateIcons } from '@shiftparadigm/eds-core/utils/decorateIcons';
import { loadBlocks } from '@shiftparadigm/eds-core/utils/loadBlocks';

export async function loadErrorPage() {
	const htmlText = await fetch('/404.html').then((response) => {
		if (response.ok) {
			return response.text();
		}
		throw new Error('Error getting 404 page');
	});
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlText, 'text/html');
	document.body.innerHTML = doc.body.innerHTML;
	document.head.innerHTML = doc.head.innerHTML;

	await loadBlocks(document.body);
	decorateIcons(document.body);
	// https://developers.google.com/search/docs/crawling-indexing/javascript/fix-search-javascript
	// Point 2. prevent soft 404 errors
	const metaRobots = document.createElement('meta');
	metaRobots.name = 'robots';
	metaRobots.content = 'noindex';
	document.head.appendChild(metaRobots);

	// When moving script tags via innerHTML, they are not executed. They need to be re-created.
	const notImportMap = (c: HTMLScriptElement) =>
		c.textContent && c.type !== 'importmap';
	Array.from(document.head.querySelectorAll('script'))
		.filter(notImportMap)
		.forEach((c) => c.remove());
	Array.from(doc.head.querySelectorAll('script'))
		.filter(notImportMap)
		.forEach((oldScript) => {
			const newScript = document.createElement('script');
			Array.from(oldScript.attributes).forEach(({ name, value }) => {
				newScript.setAttribute(name, value);
			});
			const scriptText = document.createTextNode(oldScript.innerHTML);
			newScript.appendChild(scriptText);
			document.head.appendChild(newScript);
		});
}
